import type { ChatHelp } from "./chat-contracts";

/** Only established app destinations are navigable; generated actions remain prose. */
export const chatHelpDestinations = {
  connections: { instruction: "Set up connections", title: "Open connections", href: "/profile" },
  sharing: { instruction: "Set up sharing", title: "Open sharing setup", href: "/getting-started/setup" },
  setup: { instruction: "Get started", title: "Open getting started", href: "/setup" },
  collections: { instruction: "Browse collections", title: "Open collections", href: "/collections" },
  tags: { instruction: "Browse tags", title: "Open tags", href: "/tags" },
  stashes: { instruction: "Browse stashes", title: "Open stashes", href: "/stashes" },
} as const;
export type ChatHelpActionId = keyof typeof chatHelpDestinations;
export const isChatHelpActionId = (value: unknown): value is ChatHelpActionId =>
  typeof value === "string" && Object.prototype.hasOwnProperty.call(chatHelpDestinations, value);
const topicActions: Record<string, readonly ChatHelpActionId[]> = {
  about: ["setup"],
  platforms: ["sharing"],
  sharing: ["sharing"],
  imports: ["connections"],
  "import-recovery": ["connections"],
  saving: ["stashes"],
  "map-and-events": ["stashes"],
  "tags-and-collections": ["collections", "tags"],
  "collection-access": ["collections"],
};
export function chatHelpActions(help?: ChatHelp): readonly ChatHelpActionId[] {
  return help
    ? help.actions
      ? [...new Set(help.actions.map(action => action.id))]
      : topicActions[help.id || ""] || []
    : [];
}
